<template>
<div class="chapter">
<div class="inner_page">
<p class="C264"><a id="page_17">KIM ADDONIZIO</a></p><a id="page_17">
<p class="C256"><em>HANSEL</em></p>
<p class="C312">We my sister Gretel, oh Gretel left our father’s house and scattered and lost did not stop at her old witch woman’s cottage candy hungry but kept on into the world, woods. We were set upon by rebels guerillas tribesmen revolutionaries who they raped cut off and stabbed left I my sister Gretel, Gretel for dead graves hands, for two days nearly to get we circled back; her cottage, burned ruin, hungry kept us alive. Then Gretel in the night died a creature something dragged her out and half-devoured her it. I filled my pockets I walked I Hansel out recognizing nothing birds circling above me I was a child who liked sweets this is my testimony what I broken know and don’t forget everything has to eat.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Hansel.vue?65aa84aa